import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ListGroup, Badge, Container, Row, Col, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';

const GroceryOffersLatest = ({ width, height }) => {
    const [groceryOffers, setGroceryOffers] = useState([]);

    const pageSize = 3; // Number of offers to fetch per page

    const fetchGroceryOffers = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/highgarden/grocery-offers/`, {
                headers: { Authorization: `Token ${token}` },
                params: {
                    page_size: pageSize,
                    offer_status: 'ACTIVE',
                    favorite_store: true,
                },
            });
            setGroceryOffers(response.data.results);
        } catch (error) {
            console.error('Error fetching grocery offers:', error);
        }
    };

    useEffect(() => {
        fetchGroceryOffers();
    }, []);

    return (
        <Container style={{ width: width, height: height }}>
            <Row>
                <Col>
                    <h6 className="pt-0">Latest Grocery Offers</h6>
                    {groceryOffers.length > 0 ? (
                        <ListGroup variant="flush">
                            {groceryOffers.map((offer) => {
                                // Format start and end dates
                                const formattedStartDate = moment(offer.start_date).format('MMMM Do, YYYY');
                                const formattedEndDate = moment(offer.end_date).format('MMMM Do, YYYY');

                                // Count the number of stores
                                const storeCount = offer.stores.length;

                                return (
                                    <ListGroup.Item
                                        key={offer.id}
                                        className="d-flex justify-content-between align-items-start py-1" // Changed align-items-center to align-items-start
                                        style={{ paddingLeft: '0px' }}>
                                        <div>
                                            <strong className="small">{offer.name}</strong>
                                            <div className="small text-muted">
                                                {formattedStartDate} - {formattedEndDate}
                                            </div>
                                        </div>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    Offer available in {storeCount} {storeCount === 1 ? 'store' : 'stores'}.
                                                </Tooltip>
                                            }>
                                            <Badge bg="danger" className="small">
                                                {storeCount} {storeCount === 1 ? 'store' : 'stores'}
                                            </Badge>
                                        </OverlayTrigger>
                                    </ListGroup.Item>
                                );
                            })}
                        </ListGroup>
                    ) : (
                        <Alert>No active grocery offers available.</Alert>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default GroceryOffersLatest;
